import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './TermsAcceptance.css';

const TermsAcceptance = ({ checked, onChange, disabled, id }) => (
    <div className="xk-terms-wrap">
      <label className="xk-terms" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className="xk-terms__input"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="xk-terms__box" aria-hidden="true" />
        <span className="xk-terms__text">
          I accept the{' '}
          <Link
            className="xk-terms__link"
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            Terms &amp; Conditions
          </Link>
        </span>
      </label>
    </div>
);

TermsAcceptance.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

TermsAcceptance.defaultProps = {
  disabled: false,
  id: 'auth-terms',
};

export default TermsAcceptance;
